/* rules.js — upper-line / unit-level rule resolution.
 * Ported from lhc-app.html ~32968–33013 (_ruleVal, getWorktopTopM, getUpperLineM, lhcRoleBaseY).
 *
 * Pure: pass the kitchenWizard object explicitly (no globals). A wizard override wins
 * only if it is a finite number > 0; otherwise the LHC_RULES default applies.
 */
import { LHC_RULES, UPPER_LINE_M } from "./constants";

const RULE_FIELD = {
  PLINTH_H: "rulePlinthH",
  CARCASS_BASE_H: "ruleCarcassH",
  WORKTOP_T: "ruleWorktopT",
  SPLASH_GAP: "ruleSplashGap",
};

/** _ruleVal(key, wizField): override (finite > 0) else LHC_RULES[key]. (~32968) */
export function ruleVal(key, wizard) {
  const wizField = RULE_FIELD[key];
  const v = wizard ? wizard[wizField] : null;
  return typeof v === "number" && isFinite(v) && v > 0 ? v : LHC_RULES[key];
}

/** Worktop TOP height = plinth + base carcass + worktop thickness (m). (~32974) */
export function getWorktopTopM(wizard) {
  return ruleVal("PLINTH_H", wizard) + ruleVal("CARCASS_BASE_H", wizard) + ruleVal("WORKTOP_T", wizard);
}

/** Upper line (bottom of wall units).
 *  2026-08-18 hardcode purge: the wizard's Walls step has ALWAYS collected a
 *  "wall unit height" (wizardRules wallUnitHeight, mm, validated 1200-2200)
 *  and the engine ignored it — a customer typed a number and nothing moved.
 *  The value now installs here (same mutable-global idiom as WALL_THICKNESS)
 *  and every consumer (3D, elevation, present, order payload) follows it. */
let _upperLineM = UPPER_LINE_M;
export function setUpperLineFromWizard(wizard) {
  const mm = wizard ? Number(wizard.wallUnitHeight) : NaN;
  _upperLineM = (Number.isFinite(mm) && mm >= 1200 && mm <= 2200) ? mm / 1000 : UPPER_LINE_M;
  return _upperLineM;
}
export function getUpperLineM() {
  return _upperLineM;
}

/** Per-role default mounting height (m). (~33003 lhcRoleBaseY) */
export function roleBaseY(def) {
  if (!def) return 0;
  if (def.role === "cabinet-wall") return getUpperLineM();
  if (def.role === "cabinet-stack") return getUpperLineM() + 0.72;
  if (def.role === "cabinet-bridge") return Math.max(0, 2.1 - (def.height || 0.36));
  return 0;
}

export { LHC_RULES };
